import { BButtonGroup } from './button-group';
import { pluginFactory } from '../../utils/plugins';
var ButtonGroupPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BButtonGroup: BButtonGroup,
    BBtnGroup: BButtonGroup
  }
});
export { ButtonGroupPlugin, BButtonGroup };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/button-group/index.js
// module id = 159
// module chunks = 0